import React from 'react';

import { CompanyProfile } from '../Vendors/Profile';
import { Company } from '../../interfaces/users.interface';
import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import { USER_TYPES } from '../../services/user';

export default function CompanyDetail() {
  const params = useParams();
  const companyId: string = params.companyId!;
  const { user } = useAppSelector(state => state.user);

  if (!user || !companyId) return null;

  // Assessors and vendor admins may only view their own company.
  const restrictedToOwnCompany = user.type === USER_TYPES.ASSESSOR || user.type === USER_TYPES.VENDOR_ADMIN;
  if (restrictedToOwnCompany && (user.companies[0]?.id as number) !== parseInt(companyId)) return null;

  // CompanyProfile renders entirely from the /company-detail/ endpoints, so it
  // only needs the id; the survey flow fetches the full company on demand.
  return <CompanyProfile company={{ id: parseInt(companyId) } as Company} />;
}
